import React, { useEffect, useState, useRef } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useUser } from './UserContext';
import { initialiseBaseSkins, initialiseUserSkin, getPendingUsers, pfpOrderPageSkin, logout } from '../Users';
import LogoCircleShort from './svgs/LogoCircleShort';
import { useGroupOrder } from './GroupOrderContext';
import SearchIcon from '@mui/icons-material/Search';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FolderIcon from '@mui/icons-material/Folder';
import LogoutIcon from '@mui/icons-material/Logout';
import SchoolIcon from '@mui/icons-material/School';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PaymentIcon from '@mui/icons-material/Payment';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsIcon from '@mui/icons-material/Notifications';

export default function Willowweb() {
    const navigate = useNavigate()
    const [isClicked, setClicked] = useState(false);
    const { currentUser } = useUser();
    const { setGroupOrder } = useGroupOrder();
    const [ pfp, setPfp] = useState(null);
    const [ logoColor, setLogoColor] = useState("#4B50EE")
    const [ search, setSearch] = useState("");
    const [ pendingUsers, setPendingUsers] = useState(0);
    const [ noticeOpen, setNoticeOpen ] = useState(true);
    const dropdownRef = useRef(null);
    
    useEffect(() => {
        initialiseBaseSkins(currentUser.id);
        const fetchPfp = async () => {
            try {
                const response = await pfpOrderPageSkin(currentUser.id)
                setPfp(response.pfp); // assuming pfp is in response.data
                setGroupOrder(response.group_order);
                const userSkin = JSON.parse(response.page_colors.replace(/'/g, '"'))
                initialiseUserSkin(userSkin);
                setLogoColor(userSkin[0]);
                //setLogoColor("#3337b0");
                if (currentUser.id === 1) {
                    const {pendingCount} = await getPendingUsers();
                    setPendingUsers(pendingCount);
                }
            } catch (error) {
                console.error("Error fetching pfp:", error);
            }
        };
    
        fetchPfp(); // call the async function
    }, [currentUser.id, setGroupOrder]); // make sure the effect reruns if currentUser.id changes

    function handleChange(event) {
        const { value } = event.target;
        setSearch(value);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (search.length > 0) {
            navigate(`/search?q=${encodeURIComponent(search)}&p=1&f=e&s=rel`);
        }
    }

    function updateClicked() {
        setClicked((prevVal) => {
            return !prevVal;
        })
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setClicked(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    

    async function handleLogout() {
        try {
            const response = await logout();
            if (response.status === 200) {
                navigate('/login')
            } 
        } catch (error) {
            console.error('Error:', error);
        }
    }

    let clickedStyle = {
        height: "238px"
    }
    if(currentUser.id === 1) {
        clickedStyle = {
            height: "272px"
        }
    }

    return (
        <div>
            <header>
                <div id="logo">
                    {/* <a  href="/"><LogoHeader currentColor={logoColor} width="150px"/></a> */}
                    {/* <a  href="/"><LogoCircleLong id="logo-circle" currentColor={logoColor} width="39px"/></a> */}
                    <a  href="/"><LogoCircleShort id="logo-circle" currentcolor={logoColor} width="39px"/></a>
                    {/* <a id="logo-title" href="/"><LogoText currentColor={logoColor} width="200px"/></a> */}
                    <a id="logo-title" href="/"><h1>willow web</h1></a>
                </div>
                <form className="search-container" role="search" onSubmit={handleSubmit}>
                    <input 
                        type="text" 
                        placeholder="search.." 
                        onChange={handleChange}
                        value={search}
                    />
                    <button type="submit"><SearchIcon /></button>
                </form>
                <div id="menus-container">
                    {currentUser.id === 1 && <Link to={'/manageusers/1'} className="header-icon-container" >
                        <NotificationsIcon style={{color: pendingUsers > 0? "red" : "none"}} className="header-icon"/>
                    </Link>}
                    <Link to={`/people/${currentUser.id}`} className="header-icon-container">
                        <PeopleAltIcon className="header-icon"/>
                    </Link>
                    <div id="pfp-container">
                        <Link to={`profile/${currentUser.id}`}>
                            {pfp? 
                                <img id="pfp"  src={pfp} alt="user profile"/> : 
                                <PersonIcon id="pfp"
                            />}
                        </Link >
                    </div>
                    <div id="options-container">
                        <div ref={dropdownRef}>
                            <ExpandMoreIcon id="arrow" onClick={updateClicked} />
                            <div className="header-menu" style={isClicked? clickedStyle : null}>
                                <Link to={`/profile/${currentUser.id}`} onClick={updateClicked}><PersonIcon className="menu-icon"/>profile</Link >
                                <Link to={`/settings/${currentUser.id}`} onClick={updateClicked}><SettingsIcon className="menu-icon"/>settings</Link >
                                <Link to={`/manage/pages/${currentUser.id}`} onClick={updateClicked}><FolderIcon className="menu-icon"/>page manager</Link >
                                <Link to={`/manage/skins/${currentUser.id}`} onClick={updateClicked}><AutoAwesomeIcon className="menu-icon"/>skin manager</Link >
                                <Link to={`/1/page/1`} onClick={updateClicked}><SchoolIcon className="menu-icon"/>willow web docs</Link >
                                <Link to={`/subscription/${currentUser.id}`} onClick={updateClicked}><PaymentIcon className="menu-icon"/>subscription</Link >
                                {currentUser.id === 1 && <Link to={'/createuser/1'} onClick={updateClicked}><PersonAddIcon className="menu-icon"/>create user</Link >}
                                <div onClick={handleLogout}><LogoutIcon className="menu-icon"/>log out</div >
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {currentUser.status === -1 && 
                <div className="notice">you have been banned. no one can access your page. you may copy your content to somewhere else, but you have no other abilities.</div>
            }
            {(currentUser.status === 0 || currentUser.status === 1) && currentUser.blockCount >= 10 && noticeOpen &&
                <div className="notice">
                    <p>
                        you have reached the block limit of 10 for non-paying users. please go to {" "}
                        <Link to={`/payment/${currentUser.id}`}>payment</Link>{" "}
                        if you'd like to become an active user.
                    </p>
                    <CloseIcon onClick={() => {setNoticeOpen(false)}}/>
                </div>
            }
            {(currentUser.status === 0 || currentUser.status === 1) && currentUser.blockCount === 1 && noticeOpen &&
                <div className="notice">
                    <p>
                        welcome to willow web ! there's a guide on how to use the site in the{" "}
                        <Link to="/1/page/1">willow web docs</Link>{" "}
                        . have fun !
                    </p>
                    <CloseIcon onClick={() => {setNoticeOpen(false)}}/>
                </div>
            }
            <div id="body">
                <Outlet/>
            </div>
        </div>
        );
}